export type PartnerRatingTypePosition = 1 | 2 | 3 | null;

// У выездных блоки 4-5 рейтинга v2 — SLA и Количество заявок вместо Текучести и QMPC
export type ServiceTypeKind = 'INSIDE' | 'OUTSIDE';

export interface IPartnerRatingByPartner {
  ratingPosition: number;
  serviceTypeId: number;
  serviceTypeName: string;
  partnerGuid: string;
  partnerName: string;
  partnerDirector: string;
  partnerPhone: string;
  partnerBin: string;
  ratingSum: number;
  realEstateCount: number;
  typePosition: PartnerRatingTypePosition;
  months: IPartnerRatingByMonth[];
  realEstates: IRealEstateRatingByPartner[];
  // Карточка всегда под один вид услуги — признак один на всю таблицу
  serviceTypeKind?: ServiceTypeKind;
}

export interface IPartnerRatingByPartnerUgo
  extends Omit<IPartnerRatingByPartner, 'partnerGuid' | 'partnerName' | 'realEstates'> {
  nomenclaturaGuid: string;
  nomenclaturaName: string;
  smrPartnerGuid: string;
  smrPartnerName: string;
  applicationsCount: number;
  realEstates: IRealEstateRatingByPartnerUgo[];
}

export interface IRealEstateRatingByPartner {
  realEstatePartnerRatingId: number;
  realEstateGuid: string;
  realEstateName: string;
  dateAt: string;
  actOvks: number;
  countOvks: number;
  countNegative: number;
  countPositive: number;
  countOvksNegative: number;
  countOvksPositive: number;
  ratingPositive: number;
  ratingOvksPositive: number;
  ratingNegative: number;
  ratingOvksNegative: number;
  ratingMo: number;
  ratingOvks: number;
  ratingPositiveNegative: number;
  ratingSum: number;
  criteriaRatings: ICriteriaRating[];
  // Методика v2 (приходят из эндпоинта /partner/rating/v2/listByPartner). Опциональны: в v1-ответе их нет.
  version?: number;
  nps?: number;
  staffTurnover?: number;
  qmpc?: number;
  relationRating?: number;
  qualityRating?: number;
  npsRating?: number;
  turnoverRating?: number;
  qmpcRating?: number;
  // Выездные блоки: приходят только у строк выездной методики, null — блока в месяце не было
  overdueRating?: number | null;
  applicationCountRating?: number | null;
  overdueShare?: number | null;
  applicationCount?: number | null;
  applicationOverdueCount?: number | null;
  applicationRealEstateCount?: number | null;
  applicationAvgCount?: number | null;
}

// Детализация NPS по ЖК за месяц (GET /partner/rating/v2/nps/{realEstateGuid}?date=).
export interface INpsDetail {
  realEstateGuid: string;
  dateAt: string;
  nps: number;
  responseCount: number;
  promoterCount: number;
  neutralCount: number;
  detractorCount: number;
  promoterPercent: number;
  neutralPercent: number;
  detractorPercent: number;
  color: string | null;
  comment: string | null;
}

export interface IRealEstateRatingByPartnerUgo
  extends Pick<IRealEstateRatingByPartner, 'realEstateGuid' | 'realEstateName' | 'dateAt'> {
  ratingSum: number | null;
  criteriaRatings: Pick<ICriteriaRating, 'criteriaRatingId' | 'criteriaRatingName' | 'value'>[];
}

export interface IPartnerRatingByMonth {
  dateAt: string;
  ratingSum: number;
  realEstatePartnerRatingId: number | null;
}

export interface IServiceOrg {
  serviceOrgGuid: string;
  serviceOrgName: string;
  currentName: string;
}

export interface IArea {
  areaId: number;
  areaName: string;
}

export interface IRealEstate {
  realEstateGuid: number;
  realEstateName: string;
}

export interface IPartner {
  partnerGuid: string;
  partnerName: string;
}

export enum ECriteriaRatingType {
  Boolean = 'bool',
  Mark = 'mark',
}

export interface ICriteriaRating {
  criteriaRatingId: number;
  criteriaRatingName: string;
  ratingTrue: number;
  ratingFalse: number;
  value: number | string;
  type: ECriteriaRatingType;
}

export interface IServiceType {
  serviceTypeId: number;
  serviceTypeName: string;
  // Подстраховка, если карточка партнёра пришла без serviceTypeKind
  type?: ServiceTypeKind;
}
